// src/components/Admin/InstitutionCmp/InstitutionProfile/InstitutionPlan.js
import React from "react";
import { Table, Image } from "semantic-ui-react";

export function InstitutionPlan({ data }) {
  const { planEduca, expired_at } = data;
  if (!planEduca) {
    return <p>No hay plan asignado.</p>;
  }
  const fmt = iso => iso ? new Date(iso).toLocaleDateString() : "–";
  const {
    title,
    miniature,
    account,
    price,
    accessTime,
    vrHeadsetNumber,
    vrHeadsetModel,
    bagModel,
    curseBasic,
    curseCertification,
    publicity,
  } = planEduca;

  return (
    <Table definition compact>
      <Table.Body>
        <Table.Row>
          <Table.Cell><Image src={miniature} size="mini" /></Table.Cell>
          <Table.Cell>{title}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Licencia</Table.Cell>
          <Table.Cell>{account}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Precio</Table.Cell>
          <Table.Cell>{price} €</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Expira</Table.Cell>
          <Table.Cell>{fmt(expired_at)}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Duración</Table.Cell>
          <Table.Cell>{accessTime} meses</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>VR</Table.Cell>
          <Table.Cell>{vrHeadsetNumber} × {vrHeadsetModel || "–"}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Maletín</Table.Cell>
          <Table.Cell>{bagModel || "–"}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Curso Básico</Table.Cell>
          <Table.Cell>{curseBasic ? "Sí" : "No"}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Certificación</Table.Cell>
          <Table.Cell>{curseCertification ? "Sí" : "No"}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Publicidad</Table.Cell>
          <Table.Cell>{publicity ? "Sí" : "No"}</Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  );
}
